import React, { useEffect } from "react";
import { initMetaPixel } from "./utils/metaPixel";
import { Hero } from "./components/Hero";
import { OfferBar } from "./components/OfferBar";
import { SamplesCarousel } from "./components/SamplesCarousel";
import { ProblemsSection } from "./components/ProblemsSection";
import { StepsSection } from "./components/StepsSection";
import { BookSection } from "./components/BookSection";
import { BonusesSection } from "./components/BonusesSection";
import { OfferDetails } from "./components/OfferDetails";
import { GuaranteeSection } from "./components/GuaranteeSection";
import { FaqSection } from "./components/FaqSection";
import { ClosingSection } from "./components/ClosingSection";
import { SiteFooter } from "./components/SiteFooter";
import { StickyOfferBar } from "./components/StickyOfferBar";
export function App() {
  useEffect(() => {
    document.title = "Senior Activity Hub | Ready-to-Lead Activity Kit";
    initMetaPixel();
  }, []);
  return <main className="w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3ik7gwiph6frp">
      <Hero data-id="element-1" data-mp="3ihuyk4ft23e4" />
      <OfferBar data-id="element-2" data-mp="3mljaezbgzl56" />
      <SamplesCarousel data-id="element-3" data-mp="3ml1419v3fqjj" />
      <ProblemsSection data-id="element-4" data-mp="3mkhou0wtvg97" />
      <StepsSection data-id="element-5" data-mp="3mjq2zht18ww4" />
      <BookSection data-id="element-6" data-mp="3mj6jhwnqi0fz" />
      <BonusesSection data-id="element-7" data-mp="3rcj2nr9n9f1c" />
      <OfferDetails data-id="element-8" data-mp="3rdas0kcnegj6" />
      <GuaranteeSection data-id="element-9" data-mp="3rcsxbs5mwadd" />
      <FaqSection data-id="element-10" data-mp="3relvej26lm9r" />
      <ClosingSection data-id="element-11" data-mp="5orh0l86u6j" />
      <SiteFooter data-id="element-12" data-mp="4wvvprmowg9" />
      <StickyOfferBar data-id="element-13" data-mp="5gel8p3rovc" />
    </main>;
}